import update from 'immutability-helper';
import { getRandomArrayElement } from '../util/getRandomArrayElement';
import { objectMap } from '../util/objectMap';

import {
   ADVANCE_TUTORIAL,
   INIT,
   SET_ALLOW_SKIP,
   SET_QUIZ_ANSWER_CORRECT,
   SUBMIT_QUIZ_ANSWER,
} from './actions';

const resolveRandomizedStep = (params, item) => {
   if (item == null) {
      return item;
   }
   if (typeof item === 'object' && item[':ref']) {
      return params[item[':ref']];
   }
   if (typeof item === 'object' && Array.isArray(item)) {
      return item.map((val) => resolveRandomizedStep(params, val));
   }
   if (typeof item === 'object') {
      return objectMap(item, (val) => resolveRandomizedStep(params, val));
   }
   if (typeof item === 'string') {
      return Object.entries(params).reduce(
         (newItem, [key, val]) => newItem.replace(`{:${key}}`, val),
         item
      );
   }
   return item;
};

const tutorialReducer = (
   state = {
      ready: false,
      section: 0,
      step: 0,
      remainingRepeats: 0,
      quizResponses: [],
      quizAnswerSubmitted: false,
      quizAnswerCorrect: false,
      allowSkip: false,
      tutorialDocument: null,
   },
   action
) => {
   switch (action.type) {
      case INIT:
         return {
            ...state,
            ready: true,
            tutorialDocument: action.tutorialDocument,
         };

      // This doesn't run for first step of a tutorial... will need to include some of this logic in INIT if that causes a problem
      case ADVANCE_TUTORIAL: {
         let nextStepIndex = state.step;
         let nextRemainingRepeats = state.remainingRepeats;
         const hasRepeated = nextRemainingRepeats > 0;

         if (hasRepeated) {
            nextRemainingRepeats -= 1;
         }

         if (nextRemainingRepeats === 0) {
            nextStepIndex += 1;
         }

         let nextState = {};
         if (
            nextStepIndex ===
            state.tutorialDocument.sections[state.section].steps.length
         ) {
            // next section
            nextState = {
               ...state,
               section: state.section + 1,
               step: 0,
               allowSkip: false,
               quizResponses: [],
               quizAnswerSubmitted: false,
               remainingRepeats: nextRemainingRepeats,
            };
         } else {
            nextState = {
               ...state,
               step: nextStepIndex,
               allowSkip: false,
               quizAnswerSubmitted: false,
               remainingRepeats: nextRemainingRepeats,
            };
         }

         const nextStep =
            nextState.tutorialDocument.sections[nextState.section].steps[
               nextState.step
            ];

         if (!hasRepeated && nextStep.repeat) {
            nextState = { ...nextState, remainingRepeats: nextStep.repeat };
         }

         if (nextStep?.isRandomized) {
            return update(nextState, {
               tutorialDocument: {
                  sections: {
                     [nextState.section]: {
                        steps: {
                           [nextState.step]: {
                              $merge: resolveRandomizedStep(
                                 getRandomArrayElement(nextStep.randomOptions),
                                 nextStep.randomizedPropertiesToResolve
                              ),
                           },
                        },
                     },
                  },
               },
            });
         }
         return nextState;
      }

      case SET_ALLOW_SKIP:
         return { ...state, allowSkip: action.allowSkip };

      case SUBMIT_QUIZ_ANSWER:
         return { ...state, quizAnswerSubmitted: true };

      case SET_QUIZ_ANSWER_CORRECT:
         return update(state, {
            quizResponses: { $push: [action.quizAnswerCorrect] },
            quizAnswerCorrect: { $set: action.quizAnswerCorrect },
         });

      default:
         return state;
   }
};

export { tutorialReducer };
